<template>
  <section id="general-settings">
    <b-overlay :show="showContent" spinner-variant="primary" variant="transparent" blur="3px" rounded="sm">
      <b-card title="General Settings">
        <b-form>
          <div v-for="(item, idx) in items" :key="item.id">
            <b-form-group :label="item.key" :label-for="'item-' + idx">
              <b-input-group>
                <b-form-input :id="'item-' + idx" v-model="item.value" type="text" />
                <b-input-group-append>
                  <b-button size="sm" variant="primary" @click="updateSettings(item)">
                    Update
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </section>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
} from "bootstrap-vue"
import axios from "axios"

export default {
  components: {
    BCard,
    BCardHeader,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
  },
  data() {
    return {
      showContent: true,
      items: [],
      queryParams: {},
    }
  },
  methods: {
    async getGeneralSettings() {
      await axios
        .get(process.env.VUE_APP_ROOT_API + "/general-settings/", {
          headers: {
            "Authorization": `JWT ${this.$store.state.jwt}`,
            "Content-Type": "application/json"
          },
          params: this.queryParams,
        })
        .then(response => {
          this.items = response.data.results || response.data
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$router.push({ name: "login" })
          }
        })
    },
    async updateSettings(item) {
      try {
        await axios.patch(
          `${process.env.VUE_APP_ROOT_API}/nanostore-settings/${item.id}/`,
          { value: item.value },
          {
            headers: {
              Authorization: `JWT ${this.$store.state.jwt}`,
              "Content-Type": "application/json",
            },
          }
        )
        this.$toast.success('Value updated!')
      } catch (error) {
        this.$toast.error('Update failed')
      }
    },
  },
  async created() {
    this.showContent = true
    Promise.all([
      await this.getGeneralSettings(),
    ]).finally(() => {
      this.showContent = false
    })
  }
}
</script>